import Utils from './Utils.jsx';
import { uploadOfflineChange } from '../offline-features/db.js';
import { getDatasets } from '../offline-features/getDatasets.js';
import { setDatasets } from '../context/datasets.js';
import { loadFreshProject } from './openProject.js';
import { shouldUseDevMockProjects } from './devMockProjects.js';
import { setEmailAddress } from '../context/emailAddress.js';
import { setCreateDate } from '../context/createDate.js';
import { setTourInfo } from '../context/tourInfo.js';
import { setIsSuperAdmin } from '../context/isSuperAdmin.js';
import { setMustChangePassword } from '../context/mustChangePassword.js';
import { openAlert } from '../context/alert.js';

// on startup, fetch a bunch of data and set it in context
export const startup = ({dispatch, datasets, datasetId, emailAddress}) => {
	// A restored /app/dataset/:id must reload the project list. The list is what
	// carries the Gantt timescale, and an in-memory copy can still be empty.
	const load = () => {
		if (datasetId) {
			loadFreshProject({ dispatch, datasetId }).catch(() => {
				// API failures already surface via Utils.ajax alerts.
			});
			return;
		}
		if (datasets && Object.keys(datasets).length > 0) {
			return;
		}
		getDatasets(dispatch).then(result => {
			if (result.success) {
				dispatch(setDatasets(result.datasets));
			}
		}).catch(() => {
			// API failures already surface via Utils.ajax / ajaxAsync alerts.
		});
	};
	// A direct /app/dataset/:id must paint even if an offline upload never
	// calls back. Sync still runs, and a finished sync reloads that project.
	load();
	if (!shouldUseDevMockProjects()) {
		uploadOfflineChange(dispatch, () => {
			if (datasetId) {
				load();
			}
		});
	}
	if (!emailAddress) {
		if (shouldUseDevMockProjects()) {
			dispatch(setEmailAddress('dev@localhost'));
			dispatch(setTourInfo({ 1: 1, 2: 1, 4: 1 }));
			return;
		}
		Utils.ajax('getUserInfo', {}, dispatch, result => {
			const { success, emailAddress, createDate, tourInfo, isSuperAdmin, mustChangePassword } = result;
			if (success) {
				dispatch(setEmailAddress(emailAddress));
				dispatch(setCreateDate(createDate));
				dispatch(setTourInfo(Array.isArray(tourInfo) ? {} : tourInfo));
				dispatch(setIsSuperAdmin(Boolean(isSuperAdmin)));
				dispatch(setMustChangePassword(Boolean(mustChangePassword)));
				if (mustChangePassword) {
					dispatch(openAlert(
						'Change your password',
						'Your account was created with a temporary password. Please change it under Account settings (Setup).'
					));
				}
			}
		});
	}
};
